// Pure bits of the Likeness recorder. Kept out of the component so a
// case-insensitive disk does not collide with LikenessTake.js.

export const VOICE_SCRIPT = 'This is my own voice. I am recording it on this computer, for me. The birch canoe slid on the smooth planks. Glue the sheet to the dark blue background. Those thieves stole thirty jewels. Ask me something and I will answer like this.';

export const VIDEO_CUE = 'Look into the camera and say: Hi, this is me. This is my face when I talk. Then pause, and smile.';

export const TAKE_LIMITS = { voice: 60, video: 30 };

const VOICE_TYPES = ['audio/webm;codecs=opus', 'audio/webm', 'audio/mp4'];
const VIDEO_TYPES = ['video/webm;codecs=vp8,opus', 'video/webm', 'video/mp4'];

export function pickMime(kind, supported) {
  const list = kind === 'voice' ? VOICE_TYPES : VIDEO_TYPES;
  return list.find((t) => supported(t)) || '';
}

export function extFor(mime) {
  const base = String(mime || '').split(';')[0];
  if (base.endsWith('mp4')) return 'mp4';
  if (base.endsWith('ogg')) return 'ogg';
  return 'webm';
}

// Raw-bucket uploads only accept keys under items/.
export function takeKey({ orgId, appId, uid, mime }) {
  return `items/likeness/${orgId}/${appId}/${uid}/${Date.now()}.${extFor(mime)}`;
}
